import React, { useState, useEffect } from 'react';
import Axios from "axios";
import { deactivateClientByClientId, GetClients } from '../apiconstants/constants';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import nodataimg from "../assets/images/Nodata.jpg";
import LoadingSpinner from '../helpers/loadingspinner';
import ConsultantLayout from '../commonlayouts/consultantlayout';
import AdminLayout from '../commonlayouts/adminlayout';
import axios from 'axios';
import { Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ListOfClients = () => {
  const [offset, setOffset] = useState(0);
  let query = useQuery();
  const roleid = localStorage.getItem("roleID");
  const [data, setData] = useState([]);
  const [perPage] = useState(6);
  const [pageCount, setPageCount] = useState(0);
  const [clientData, setClientData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
const token = localStorage.getItem("jwtToken");
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isActive, setIsActive] = useState(Boolean);
  const [loading, setLoading] = useState(false);
  const [clientId, setClientId] = useState();
  useEffect(() => {
    GetClientList();
  }, []);

  // Function to toggle modal visibility

  const handleDeactivateClient = (id,isActive) => {
    setIsActive(isActive)
    setClientId(id);
    setShowModal(true)
  };
  const handleCloseModal = () => setShowModal(false);

  // Function to update client status

  
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * perPage);
  };

  const GetClientList = () => {
    setIsLoading(true);

    const GetapiUrl = GetClients.APIURL;

    Axios.get(GetapiUrl,
      { headers: { 'Authorization': `Bearer ${token}` } }
    )
      .then((result) => {
        setIsLoading(false);
        setClientData(result.data)
      }).catch((error) => {
        console.log("Error" + error);
      });
  };


  const handleToggleStatus = async () => {
    setLoading(true);
    try {
      const updatedStatus = !isActive; // Toggle status
      setClientData((prevClients) =>
        prevClients.map((client) =>
          client.guid === clientId ? { ...client, isActive: updatedStatus } : client
        )
      );
      await axios.put(`${deactivateClientByClientId.APIURL}?Guid=${clientId}&IsActive=${updatedStatus}`,
        {},
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      await GetClientList();
      setIsActive(updatedStatus); // Update state immediately
      handleCloseModal();
      
      // Refresh the client list without reloading
    } catch (error) {
      console.error("Error updating status:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    const filteredData = clientData.filter(candidate =>
      candidate?.companyName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      candidate?.email?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredItems(filteredData)

    const slice = filteredData.slice(offset, offset + perPage);
    const items = slice.map((data) => {
      const isSelected = selectedItems.some(item => item.id === data.id);

      return (
        <div className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3" key={data.guid}>
          <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 620, height: 250, borderRadius: 20 }}>
            <div className='card-header' style={{ background: "none", minHeight: 80 }}>
              <div className='row'>
                <div className='col-8'>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Company Name</Tooltip>)}>
                    <p className="card-title text-center jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.companyName}</b></p>
                  </OverlayTrigger>
            
                </div>
                </div>
            </div>
            <div className="card-body">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Email</Tooltip>)}>
                    <p style={{ fontSize: 18 }}>{data.email}</p>
                  </OverlayTrigger>
            <OverlayTrigger 
      placement="bottom" 
      overlay={(props) => (
        <Tooltip id="tooltip" {...props}>Phone Number</Tooltip>
      )}
    >
                         <p style={{ fontSize: 18 }}>{data.mobileNumber}</p>

    </OverlayTrigger>

              </div>
                 <div className='card-footer d-flex justify-content-between'>
                <Link style={{}} to={"/Admin/EditClients?ClientId=" + data.guid}>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Edit</Tooltip>)}>
                    <button style={{ background: "none", border: "none" }}><i className="fa fa-edit" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
                  </OverlayTrigger>

                </Link>
                <OverlayTrigger
        placement="bottom"
        overlay={(props) => (
          <Tooltip id="tooltip" {...props}>
            {data.isActive ?   "Deactivate":"Activate" }
          </Tooltip>
        )}
      >
        <button
          style={{ background: "none", border: "none" }}
          onClick={() => handleDeactivateClient(data.guid, data.isActive)}
        >
          <i
            className={`fa ${data.isActive ?  "fa-toggle-on" : "fa-toggle-off"}`}
            aria-hidden="true"
            style={{ fontSize: 24, color: data.isActive ? "#00a7ac" : "gray" }}
          ></i>
        </button>
      </OverlayTrigger>
              </div>
            
          </div>
        </div>
      );
    });

    setData(items);
    setPageCount(Math.ceil(filteredData.length / perPage));
  }, [offset, searchTerm, clientData, perPage, selectedItems]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setOffset(0);
  };
  

  return (
    <AdminLayout>
      <div className='container-fluid mt-3'>
        <div className="responsive-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 className="" style={{ color: "#00a7ac" }}>List of Clients</h2>
          <div style={{ display: 'flex', alignItems: 'center' }}>
                    
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Add Clients</Tooltip>)}>
                <Link to="/Admin/AddClients">
                  <button className="btn btn-primary mr-3" btn-ype="button"><i className="fa fa-plus"></i></button>
                </Link>
              </OverlayTrigger>
        </div>
        </div>
              <hr />

        {isLoading ? (
          <center><LoadingSpinner /></center>
        ) : (
          <>
            {clientData.length > 0  && filteredItems.length > 0 ? (
              <div className="row mt-5 pb-3">
                {data}
              </div>
            ) : (
              <div className="pb-5 text-center">
                <img title='No Data' className='no-data-img' alt="no-data-img" src={nodataimg} style={{ height: 370 }} />
              </div>
            )}
          </>
        )}

        {
          clientData.length>0  && filteredItems.length  > perPage &&
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        }

<Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Body>
          Are you sure you want to {isActive ?  "deactivate" : "activate" } this client?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal} disabled={loading}>
            Cancel
          </Button>
          <Button variant={isActive ?  "danger" : "success"  } onClick={handleToggleStatus} disabled={loading}>
            {loading ? "Processing..." : isActive ? "Deactivate"  : "Activate" }
          </Button>
        </Modal.Footer>
      </Modal>
      </div>
    </AdminLayout>
  );
}

export default ListOfClients;
